module.exports = __webpack_public_path__ + "img/campus.09579ec2.jpg";